export function getQueryParam(name) {
  try {
    const query = new URLSearchParams(window.location.search);
    return query.get(name);
  } catch {
    return null;
  }
}